module.exports = __webpack_public_path__ + "static/video-preview-3.0-8bd3524747f9d6ced3546108f01c6149.mp4";